/* D.'s Nutz: Warenkorb – Mindestbestellwert 5 € mit „Auffüllen“-Knopf, Hinweis auf kostenlosen Versand ab 40 €
   und Preisangabe (Kleinunternehmer, zzgl. Versand).
   Die Versandarten gehen nach Gewicht (Kartenanzahl) und können den Mindestbestellwert nicht prüfen; deshalb sperrt
   dieses Skript die Kasse unter 5 €, und „Sofort kaufen“ auf der Produktseite ist ausgeschaltet.
   Auffüllen: Artikel „Bulk-Karten zum Auffüllen“ (Adresse /products/bulk-auffuellen, 8 Cent je Karte). */
(function () {
  var MIN = 500, FREE = 4000, FILL_URL = "/products/bulk-auffuellen.js";
  var busy = false, filler = null, fillerLoaded = false;

  function euro(cent) { return (cent / 100).toFixed(2).replace(".", ",") + " €"; }
  function cents(c) { return c % 100 === 0 ? (c / 100) + " €" : c + " Cent"; }

  function loadFiller() {
    if (fillerLoaded) return Promise.resolve(filler);
    return fetch(FILL_URL, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        fillerLoaded = true;
        var v = p && p.variants && p.variants.find(function (x) { return x.available; });
        filler = v ? { id: v.id, price: v.price } : null;
        return filler;
      })
      .catch(function () { fillerLoaded = true; return null; });
  }

  function fillButton(box, missing) {
    var wrap = box.querySelector(".dsn-fill");
    if (!filler || missing <= 0) { if (wrap) wrap.remove(); return; }
    var n = Math.ceil(missing / filler.price), sum = n * filler.price;
    var label = "Mit " + n + " Bulk-Karten auffüllen – " + euro(sum);
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "dsn-fill";
      wrap.innerHTML = '<button type="button" class="dsn-fill__btn"></button><span class="dsn-fill__info"></span>';
      wrap.querySelector("button").addEventListener("click", function () {
        var b = this, qty = parseInt(b.getAttribute("data-qty"), 10);
        b.disabled = true; b.textContent = "Wird hinzugefügt …";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: filler.id, quantity: qty }] }) })
          .then(function () { location.reload(); })
          .catch(function () { b.disabled = false; b.textContent = label; });
      });
      var note = box.querySelector(".dsn-minnote");
      box.insertBefore(wrap, note ? note.nextSibling : box.firstChild);
    }
    var btn = wrap.querySelector("button");
    if (btn.getAttribute("data-qty") !== String(n)) {
      btn.setAttribute("data-qty", n);
      btn.textContent = label;
      wrap.querySelector(".dsn-fill__info").textContent =
        "Original Pokémon-Karten, bunt gemischt – " + cents(filler.price) + " pro Karte, aufgerundet auf den Mindestbestellwert. Wir legen sie deiner Bestellung bei.";
    }
  }

  function apply(total, count) {
    document.querySelectorAll(".cart__ctas").forEach(function (box) {
      var low = count > 0 && total < MIN;
      box.querySelectorAll('button[name="checkout"]').forEach(function (b) {
        if (low && !b.disabled) { b.disabled = true; b.setAttribute("data-dsn-min", "1"); }
        if (!low && b.hasAttribute("data-dsn-min")) { b.disabled = false; b.removeAttribute("data-dsn-min"); }
      });
      var extra = box.querySelector(".additional-checkout-buttons");
      if (extra && extra.style.display !== (low ? "none" : "")) extra.style.display = low ? "none" : "";
      var note = box.querySelector(".dsn-minnote");
      var text = low ? "Mindestbestellwert 5 € – es fehlen noch " + euro(MIN - total) + "."
        : (count > 0 && total < FREE ? "Noch " + euro(FREE - total) + " bis zum kostenlosen Versand (innerhalb Deutschlands)." : "");
      if (text) {
        if (!note) { note = document.createElement("p"); box.insertBefore(note, box.firstChild); }
        note.className = "dsn-minnote" + (low ? "" : " dsn-minnote--free");
        if (note.textContent !== text) note.textContent = text;
      } else if (note) {
        note.remove();
      }
      fillButton(box, low ? MIN - total : 0);
      if (!box.querySelector(".dsn-pricenote")) {
        var p = document.createElement("p");
        p.className = "dsn-pricenote";
        p.innerHTML = 'Endpreise, gemäß § 19 UStG ohne Umsatzsteuer · zzgl. <a href="/policies/shipping-policy">Versand</a> (ab 40 € versandkostenfrei)';
        box.appendChild(p);
      }
    });
  }

  function check() {
    if (busy || !document.querySelector(".cart__ctas")) return;
    busy = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var total = c.items_subtotal_price, count = c.item_count;
        return (total < MIN && count > 0 ? loadFiller() : Promise.resolve(null)).then(function () {
          busy = false; apply(total, count);
        });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener("DOMContentLoaded", check);
  document.addEventListener("cart:update", check);
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(check, 300); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
